import React, { useEffect, useState, useMemo } from "react";
import { Col, Row, Card, Spin, Pagination, Select, Input, Drawer } from "antd";
import { Button } from 'react-bootstrap';
import { LoadingOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import _isEmpty from "lodash/isEmpty";
import { SearchOutlined } from "@ant-design/icons";
import _slice from "lodash/slice";
import {
	fetchCompanyInfoRequest,
	fetchTagsInfoRequest,
} from "../../appRedux/actions/ExhibitorFloor";
import { ExhibitorProfile } from "../Modals";
import Filter from "./Filter";
import { isValidImage } from "../../utils";

const Directory = props => {
	const [exhibitorsInfo, setExhibitorInfo] = useState([]);
	const [supportType, setSupportType] = useState([]);
	const [checkedData, setCheckedData] = useState([]);
	const [showExhibitorModal, setShowExhibitorModal] = useState(false);
	const [selectedExhibitor, setSelectedExhibitor] = useState(false);
	const [exhibitorsKeyList, setExhibitorskeyLists] = useState({});
	const [showSizeChange, setShowSizeChange] = useState(12);
	const [matchedExhibInfo, setMatchedExhibInfo] = useState([]);
	const [searchValue, setSearchValue] = useState("");
	const [drawerVisible, setDrawerVisible] = useState(false);
	const [currentPageNumber, setCurrentPageNumber] = useState(1);
	const [windowSize, setWindowSize] = useState(window.innerWidth);

	const handleExhibTypeInfo = useMemo(() => {
		let exhibTypeLists = [];
		if (!_isEmpty(props.config) && !_isEmpty(props.exhibitor)) {
			let badgeObj = {};
			let exhibTypeObj = {};
			props.config.sponsor_config.map(item => {
				badgeObj = { ...badgeObj, [item.label]: item };
			});
			props.exhibitor.companyInfo.map(data => {
				if (data.CompanyInfo.support_level === badgeObj[data.CompanyInfo.support_level]?.label) {
					data["badgeObj"] = badgeObj[data.CompanyInfo.support_level];
				} else {
					data["badgeObj"] = { order: "99", value: "", label: "", badge_icon: "", badge_color: "" };
				}
				if (exhibTypeObj[data.CompanyInfo.support_level]) {
					exhibTypeObj = {
						...exhibTypeObj,
						[data.CompanyInfo.support_level]: [
							...exhibTypeObj[data.CompanyInfo.support_level],
							data,
						],
					};
				} else {
					exhibTypeObj = { ...exhibTypeObj, [data.CompanyInfo.support_level]: [data] };
				}
			});
			if (!_isEmpty(exhibTypeObj)) {
				Object.keys(badgeObj).map(sType => {
					if (exhibTypeObj[sType]) {
						exhibTypeLists = [...exhibTypeLists, ...exhibTypeObj[sType]];
					}
				});
			}
		}
		return exhibTypeLists;
	}, [props.config, props.exhibitor]);
	useEffect(() => {
		if (!_isEmpty(props.config) && !_isEmpty(props.exhibitor)) {
			let exhibitorList = [...props.exhibitor.companyInfo];
			let exhibTypes = [...props.config.sponsor_config];
			for (let i = 0; i < exhibTypes.length; i++) {
				let exhibs = exhibitorList.filter(exhibitor => {
					return exhibitor.badgeObj.label === exhibTypes[i].label;
				});
				exhibTypes[i].count = exhibs.length;
			}
			exhibTypes = exhibTypes.filter(v => v.count > 0);
			setSupportType(exhibTypes);
			setExhibitorInfo(sliceData(handleExhibTypeInfo));
			setMatchedExhibInfo(handleExhibTypeInfo);
		}
	}, [props.config, props.exhibitor, handleExhibTypeInfo]);

	useEffect(() => {
		if (!_isEmpty(checkedData) && !_isEmpty(props.config) && !_isEmpty(props.exhibitor)) {
			let filterExhibitor = [];
			handleExhibTypeInfo.map(info => {
				if (checkedData.includes(info.CompanyInfo.support_level)) {
					filterExhibitor = [...filterExhibitor, info];
				}
			});
			setMatchedExhibInfo(filterExhibitor);
			setExhibitorInfo(sliceData(filterExhibitor));
		} else {
			setMatchedExhibInfo(handleExhibTypeInfo);
			setExhibitorInfo(sliceData(handleExhibTypeInfo));
		}
	}, [checkedData]);

	useEffect(() => {
		if (!_isEmpty(exhibitorsInfo)) {
			let exhibitorsObj = {};
			exhibitorsInfo.map(item => {
				exhibitorsObj = {
					...exhibitorsObj,
					[item.CompanyInfo.CompID]: { ...item.CompanyInfo, ...item },
				};
			});
			setExhibitorskeyLists(exhibitorsObj);
		}
	}, [exhibitorsInfo]);
	useEffect(() => {
		if (showSizeChange) {
			let exhibData = !_isEmpty(checkedData) || searchValue ? matchedExhibInfo : handleExhibTypeInfo;

			setMatchedExhibInfo(exhibData);
			setExhibitorInfo(sliceData(exhibData));
		}
	}, [showSizeChange]);
	useEffect(() => {
		window.addEventListener("resize", () => {
			if (window.innerWidth > 990) {
				setDrawerVisible(false);
			}
			setWindowSize(window.innerWidth);
		});
	}, [window.innerWidth]);

	useEffect(() => {
		if (searchValue) {
			exhibSearch(searchValue);
		}
	}, [checkedData]);

	const filterCheckBoxHandler = e => {
		if (!checkedData.includes(e.target.value)) {
			setCheckedData([...checkedData, e.target.value]);
		} else {
			let filterData = checkedData.filter(item => item !== e.target.value);
			setCheckedData(filterData);
		}
	};
	const handleCompanyInfo = sItem => {
		setShowExhibitorModal(!showExhibitorModal);
		setSelectedExhibitor(sItem.CompanyInfo.CompID);
	};
	const handleExhibitorModalClose = () => {
		setShowExhibitorModal(false);
	};
	const exhibSearch = keyword => {
		setSearchValue(keyword);
		setCurrentPageNumber(1)
		let result	 = [];
		let filteredExhibitor = [];
		filteredExhibitor = handleExhibTypeInfo.filter(item =>
			checkedData.includes(item.CompanyInfo.support_level)
		);
		let finalExhibitors = !_isEmpty(checkedData) ? filteredExhibitor : handleExhibTypeInfo;
		if (keyword && keyword.length > 0) {
			result = finalExhibitors.filter(v => {
				return (
					(v.CompanyInfo.Country &&
						v.CompanyInfo.Country.toLowerCase().includes(keyword.toLowerCase())) ||
					(v.CompanyInfo.Description &&
						v.CompanyInfo.Description.toLowerCase().includes(keyword.toLowerCase())) ||
					(v.CompanyInfo.Companyname &&
						v.CompanyInfo.Companyname.toLowerCase().includes(keyword.toLowerCase()))
				);
			});
			setExhibitorInfo(sliceData(result));
			setMatchedExhibInfo(result);

		} else {
			setExhibitorInfo(sliceData(finalExhibitors, currentPageNumber));
			setMatchedExhibInfo(finalExhibitors);

		}
	};

	const sliceData = (data, pageNumber = 1) => {
		if (checkedData.length) {
			pageNumber = 1;
		}
		if (pageNumber > 0) {
			pageNumber = pageNumber - 1;
		}
		return _slice(data, pageNumber * showSizeChange, pageNumber * showSizeChange + showSizeChange);
	}

	const handlePagination = e => {
		let currentPage = e - 1;
		let matchedData = _slice(
			matchedExhibInfo,
			currentPage * showSizeChange,
			currentPage * showSizeChange + showSizeChange
		);
		setCurrentPageNumber(e);
		setExhibitorInfo([...matchedData]);
	};
	const onShowSizeChange = current => {
		setShowSizeChange(current);
		setCurrentPageNumber(1);
	};
	const handleDrawer = () => {
		setDrawerVisible(true);
	};
	const handleClearFilter = () => {
		setCheckedData([]);
		setDrawerVisible(false);
	};
	const searchCount = useMemo(() => {
		let matchCount = 0;
		if (searchValue.length || !_isEmpty(checkedData)) {
			matchCount = matchedExhibInfo.length;
		} else {
			matchCount = props.exhibitor.companyInfo.length;
		}
		return matchCount;
	}, [props.exhibitor, matchedExhibInfo, searchValue, checkedData]);

	let layoutResult = window.innerWidth <= 1440 && window.innerWidth >= 1024;
	const colProps = props.isEmbed ? { span: 24 } : { xl: layoutResult ? 18 : 20, lg: 17, md: 24, xs: 24, sm: 24 }
	return (
		<>
			{props.exhibitor.loading && (
				<Spin
					className="page-loader"
					spinning={true}
					indicator={<LoadingOutlined style={{ fontSize: 30 }} />}
				></Spin>
			)}
			{!props.exhibitor.loading && (
				<>
					<Row className={props.isEmbed ? "gx-m-0" : "gx-my-5 gx-mx-4"}>
						<Col {...colProps}>
							{((windowSize <= 990 && !_isEmpty(supportType)) || props.isEmbed) && (
								<div className="gx-text-right">
									<Button type="default" onClick={handleDrawer} className={props.isEmbed ? "gx-m-3 app-text-backgroundcolor floor-card-shadow " : " app-text-backgroundcolor floor-card-shadow "}>
										Filters
									</Button>
								</div>
							)}
							{!props.exhibitor.loading && (
								<div className="gx-search-bar gx-lt-icon-search-bar gx-mt-4">
									<div className="gx-form-group">
										<Input
											type="search"
											placeholder="Search here..."
											value={searchValue}
											onChange={e => exhibSearch(e.target.value)}
											autoComplete="off"
											prefix={
												<div className="gx-px-3 gx-mt-2">
													<SearchOutlined className="search-icon" />
												</div>
											}
											className="form-control gx-algolia-search-box directory-search-box"
											id="q"
											size="large"
										/>
									</div>
									 <div className="gx-d-lg-flex gx-d-md-flex gx-d-sm-block gx-justify-content-between gx-mt-4 gx-mx-2">
										<div className="gx-m-2 search-result">{searchCount} results found</div>
										<Select size="large" defaultValue={12} onChange={onShowSizeChange} autoFocus={false}>
											<Select.Option value={12}>12 / page</Select.Option>
											<Select.Option value={24}>24 / page</Select.Option>
											<Select.Option value={48}>48 / page</Select.Option>
											<Select.Option value={102}>96 / page</Select.Option>
										</Select>
									</div> 
								</div>
							)}
							<Row>
								{exhibitorsInfo.map((data, index) => {
									return (
										<Col
											xl={8}
											lg={8}
											md={12}
											sm={24}
											xs={24}
											className="gx-my-4"
											key={`col${index}`}
										>
											<Card
												className="floor-card-shadow gx-card-widget gx-pointer"
												onClick={() => handleCompanyInfo(data)}
												key={`card${index}`}
												style={{ minHeight: 370, paddingBottom: 10, borderRadius: 10 }}
											>
												{data.CompanyInfo?.support_level && (
													<span
														key={`span${index}`}
														className="gx-widget-badge badgeHeader"
														style={{ backgroundColor: data.badgeObj?.badge_color }}
													>
														{data.CompanyInfo.support_level}
													</span>
												)}
												<div className="gx-mx-3">
													<div className="badgeHeader gx-mb-2">
														<div style={{ width: "auto", height: "auto", textAlign: "center" }}>
															<div style={{ height: 40 }}></div>
															<img
																className="gx-mb-4"
																src={
																	data.CompanyInfo.CompLogo && isValidImage(data.CompanyInfo.CompLogo)
																		? data.CompanyInfo.CompLogo
																		: `https://ui-avatars.com/api/?background=D3D3D3&color=696969&name=${(data?.CompanyInfo?.Companyname || "").slice(0, (data?.CompanyInfo?.Companyname || "").lastIndexOf('(')).trim()}&size=128`
																}
																alt="..."
																style={{
																	width: "auto",
																	height: "auto",
																	maxHeight: 100,
																}}
															/>
														</div>
														<div className="badgeHeader">
															<h3 className="gx-mb-1 badgeHeader badgeCompanyName">
																{data.CompanyInfo.Companyname}
															</h3>
															<p className="gx-text-grey gx-mb-0 badgeHeader">
																{data.CompanyInfo.Country}
															</p>
														</div>
													</div>
													<div
														className="gx-mb-4 block-with-text badgeHeader"
														dangerouslySetInnerHTML={{ __html: data.CompanyInfo.Description }}
													></div>
												</div>
											</Card>
										</Col>
									);
								})}
							</Row>
						</Col>
						{!props.isEmbed && !_isEmpty(supportType) && windowSize > 990 && (
							<Col xl={layoutResult ? 6 : 4} lg={7} md={7} sm={24}>
								{!props.exhibitor.loading ? (
									<Card className="card-border-radius floor-card-shadow gx-card-widget">
										<Filter
											handleClearFilter={handleClearFilter}
											checkedBoxes={checkedData}
											supportType={supportType}
											handleFilter={filterCheckBoxHandler}
											customThemeStyle={props.customThemeStyle}
										/>
									</Card>
								) : (
									<div style={{ height: 800 }}></div>
								)}
							</Col>
						)}
					</Row>
					{matchedExhibInfo.length && (
						<div className="gx-text-center gx-mb-5">
							<Pagination
								className="gx-my-3 gx-pointer"
								total={matchedExhibInfo.length}
								pageSize={showSizeChange}
								defaultCurrent={1}
								current={currentPageNumber}
								onChange={handlePagination}
								showSizeChanger={false}
							/>
						</div>
					)}
					<div className={props.isEmbed ? 'embedDrawer' : ""}>
					<Drawer
            			placement={"right"}
						closable={false}
						onClose={() => setDrawerVisible(false)}
						visible={drawerVisible}
						getContainer={false}
						bodyStyle={{ maxWidth: 450, width: 270, padding: 22 }}
					>
						<Filter
							supportType={supportType}
							checkedBoxes={checkedData}
							handleFilter={filterCheckBoxHandler}
							handleClearFilter={handleClearFilter}
							customThemeStyle={props.customThemeStyle}
						/>
					</Drawer>
					</div>
					{showExhibitorModal && (
						<ExhibitorProfile
							show={showExhibitorModal}
							onHide={handleExhibitorModalClose}
							fullscreen={true}
							selectedExhibitor={selectedExhibitor}
							exhibitors={exhibitorsKeyList}
							exhibitorsInfo={exhibitorsKeyList}
							tagsInfo={props.tags}
							handleExhibitorModalClose={handleExhibitorModalClose}
							supportLevel={true}
							customThemeStyle={props.customThemeStyle}
							config={props.config}
						/>
					)}
				</>
			)}
		</>
	);
};

const mapStateToProps = ({ exhibFloor }) => {
	return {
		customThemeStyle: exhibFloor.customThemeStyle,
		exhibitor: exhibFloor,
		config: exhibFloor.config,
		tags: exhibFloor.tagsList,
		customThemeStyle: exhibFloor.customThemeStyle,
		isEmbed: exhibFloor.isEmbed,
	};
};

export default connect(mapStateToProps, { fetchCompanyInfoRequest, fetchTagsInfoRequest })(
	Directory
);
